var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body markdown-container markdown-disable-select",style:(_vm.containerStyle)},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }